import { z } from "zod";

export const SYMBOL_FILTER_OPERATORS = ["NOT_ILIKE", "GREATER_OR_EQ"] as const;
export type TSymbolFilterOperator = (typeof SYMBOL_FILTER_OPERATORS)[number];
export const SYMBOL_FILTER_OPERATOR_OBJ = {
  NOT_ILIKE: SYMBOL_FILTER_OPERATORS[0],
  GREATER_OR_EQ: SYMBOL_FILTER_OPERATORS[1],
} as const satisfies Record<string, TSymbolFilterOperator>;

export const filterConditionSchema = z.discriminatedUnion("operator", [
  z.object({ operator: z.literal(SYMBOL_FILTER_OPERATOR_OBJ.NOT_ILIKE), value: z.string() }),
  z.object({ operator: z.literal(SYMBOL_FILTER_OPERATOR_OBJ.GREATER_OR_EQ), value: z.number() }),
]);

export const symbolFilterSchema = z.object({
  id: z.string(),
  label: z.string(),
  propertyKey: z.string(),
  conditions: z.array(filterConditionSchema),
  enabled: z.boolean(),
  updatedAt: z.string().optional(),
});

export type SymbolFilter = z.infer<typeof symbolFilterSchema>;
